import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CategoryModule from "./CategoryModule";
import UnitModule from "./UnitModule";
import UserRoleModule from "./UserRoleModule";
import GstModule from "./GstModule"

function MastersModule() {
  return (
    <div className="App">
      <Routes>
        <Route path="/Category/*" element={<CategoryModule key="Category" />} />

        <Route path="/Unit/*" element={<UnitModule key="Unit" />} />
        <Route path="/Gst/*" element={<GstModule key="GstModule" />} />
        <Route path="/UserRole/*" element={<UserRoleModule key="UserRole" />} />
      </Routes>
    </div>
  );
}

export default MastersModule;
